var _style, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicetmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.3 90.6",
    style: {
      enableBackground: "new 0 0 90.3 90.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#006098;}\r\n\t.st1{fill:#0075C9;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.2,6.4h-69c-2.5,0-4.5,2.1-4.5,4.6v31c0,1,0.8,1.8,1.7,1.8s1.7-0.8,1.7-1.8V11c0-0.6,0.4-1,1-1h69 c0.5,0,1,0.5,1,1v69.5c0,0.6-0.4,1-1,1h-69c-0.5,0-1-0.5-1-1V56.2c0.9-0.6,1.5-1.6,1.5-2.8c0-1.8-1.5-3.4-3.3-3.4S5,51.5,5,53.4 c0,1.2,0.6,2.2,1.5,2.8v24.3c0,2.5,2,4.6,4.5,4.6h69c2.5,0,4.5-2.1,4.5-4.6V10.9C84.7,8.4,82.7,6.4,80.2,6.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.7,64.1V30.5h4.7v33.6C24.4,64.1,19.7,64.1,19.7,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,48.2c0-1,0.1-1.9,0.2-2.7s0.3-1.5,0.7-2.2c0.5-1,1.3-1.9,2.4-2.5s2.3-0.9,3.8-0.9s2.7,0.3,3.8,0.9 c1,0.6,1.8,1.5,2.4,2.5c0.3,0.6,0.6,1.3,0.7,2.2s0.2,1.7,0.2,2.7v7.9c0,1-0.1,1.9-0.2,2.7s-0.3,1.5-0.7,2.2c-0.5,1-1.3,1.9-2.4,2.5 c-1,0.6-2.3,0.9-3.8,0.9s-2.7-0.3-3.8-0.9S30.5,62,29.9,61c-0.3-0.6-0.6-1.3-0.7-2.2C29.1,57.9,29,57,29,56.1V48.2z M33.7,56.8 c0,0.9,0.2,1.6,0.6,2c0.4,0.5,1,0.7,1.7,0.7s1.3-0.2,1.7-0.7s0.6-1.1,0.6-2v-9.4c0-0.9-0.2-1.6-0.6-2c-0.4-0.5-1-0.7-1.7-0.7 s-1.3,0.2-1.7,0.7s-0.6,1.1-0.6,2V56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,64.1V35h-5.4v-4.5h15.6V35h-5.4v29.1H47.5L47.5,64.1z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.5,46v-8.1h3.7V46H76v3.8h-7.8v8.1h-3.7v-8.1h-7.8V46H64.5L64.5,46z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicetmIcon);
export default __webpack_public_path__ + "static/media/devicetmIcon.9f0b4c86e30777d5c8cb84c7461e4235.svg";
export { ForwardRef as ReactComponent };